// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 652 ? "8383b485" : chunkId) + "." + {"156":"1df872f2e4e234ae","568":"6ca586ece2e85fbf","652":"58c520462080caed"}[chunkId] + ".js";
};